import {Component, forwardRef, Injector, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-price-level-single-select-column",
    templateUrl: "./price-level-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => PriceLevelSingleSelectColumnComponent), multi: true}
    ]
})
export class PriceLevelSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent implements OnChanges {
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.field + ".priceLevelId";
        this.labelField = this.field + ".name";
    }
}
